import { render, staticRenderFns } from "./OpinionSurvey.vue?vue&type=template&id=b9634ca4&"
import script from "./OpinionSurvey.vue?vue&type=script&lang=js&"
export * from "./OpinionSurvey.vue?vue&type=script&lang=js&"
import style0 from "./OpinionSurvey.vue?vue&type=style&index=0&id=b9634ca4&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports